import { Injectable } from '@angular/core';
import { AAConstant } from 'src/app/core/models/constants';
import { RouteDataStoreService } from 'src/app/modules/aa-core/services/data-store/data-store.service';
import { AAGoogleMarkerService } from 'src/app/modules/aa-core/services/google/google-marker/aa-google-marker.service';
import { LocationService } from 'src/app/modules/aa-core/services/location-service/location.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { AppRouterDataService } from 'src/app/modules/app-routing/services/app-router-data/app-router-data.service';
import { GoogleMapType } from 'src/app/modules/google-map/enums/google-map-enum';
import { GoogleMapStoreService } from 'src/app/modules/google-map/services/google-map-store/google-map-store.service';
import { RoutePlannerService } from 'src/app/modules/route-planner/services/route-planner/route-planner.service';
import { TrafficNewsModel, TrafficNewsOption } from '../../models/traffic-news-model';
import { TrafficAlertMarkerService } from 'src/app/modules/google-map/services/marker-cluster/traffic-alert-marker.service';
import { TrafficNewsAndMapService } from 'src/app/modules/aa-core/services/traffic-news-and-map/traffic-news-and-map.service';
import { AALocationModel } from 'src/app/modules/route-planner/models/route-model';

@Injectable({
  providedIn: 'root'
})
export class TrafficNewsService extends TrafficNewsAndMapService {

  public trafficNewsModel: TrafficNewsModel;
  private trafficAlertTimer: any;

  constructor(public googleMapStore: GoogleMapStoreService,
    private appRouterDataService: AppRouterDataService,
    public routePlannerService: RoutePlannerService,
    public locationService: LocationService,
    public aaMarkerService: AAGoogleMarkerService,
    private routeDataStoreService: RouteDataStoreService,
    private trafficAlertMarkerService: TrafficAlertMarkerService) {
    super(aaMarkerService, googleMapStore, locationService, routePlannerService);

    this.trafficNewsModel = this.routeDataStoreService.trafficNewsModel;
    this.locationModel = this.trafficNewsModel.locationModel;
  }

  public initMap(params): void {
    let locationName: string = AAConstant.CURRENT_LOCATION;

    if (params[AARouterURL._LOCATION]) {
      locationName = params[AARouterURL._LOCATION];
    } else if (params[AARouterURL._LAT] && params[AARouterURL._LNG]) {
      locationName = `${params[AARouterURL._LAT]}, ${params[AARouterURL._LNG]}`;
    }

    this.locationModel.setName(locationName, this.locationModel.Name !== locationName);
    this.loadMapData(GoogleMapType.TRAFFIC_NEWS);
  }

  public onLocationReady (locationList: Array<AALocationModel>): void {
    super.onLocationReady(locationList);
    this.loadDefaltTrafficAlert();
  }

  public locationNotFound(): void {
    this.loadDefaltTrafficAlert(100);
  }

  public mapUpdateEventListener = (mapType: GoogleMapType) => {
    this.loadDefaltTrafficAlert(10);
  }

  public loadDefaltTrafficAlert(delay: number = 0): void {
    clearTimeout(this.trafficAlertTimer);
    this.trafficAlertTimer = setTimeout(() => {
      this.updateTrafficAlert(this.trafficNewsModel.trafficOptionsData);
    }, delay);
  }

  public updateRouterURL() {
    if (this.locationModel.validName()) {
      this.appRouterDataService.updateURL(AARouterURL.TRAFFIC_NEWS);
    }
  }

  public updateTrafficAlert(optionsMap: Array<TrafficNewsOption>): void {
    if (this.googleMap) {
      const selected: Array<any> = optionsMap.filter(item => {
        return (item && item.value);
      }).map(item => item.type);

      if (selected.length) {
        this.trafficAlertMarkerService.loadTrafficAlertData(this.googleMap, selected);
      } else {
        this.trafficAlertMarkerService.clearAll();
      }
    }
  }

}
